import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { AmenityListMgmt, AmenityListMgmtParams } from './model';
import { AmenityListMgmtView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export const AmenityListMgmtRoute = (model : (params : AmenityListMgmtParams) => AmenityListMgmt, appWrapper : AppWrapper, request : Location) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper}>
            <AmenityListMgmtView model={model(inboundParams(request))} />
        </AppWrapperView>
});

function inboundParams(request : Location) : AmenityListMgmtParams {
    return {
        id: +(request.params['id'] || 0)
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/amenitylistmgmt/route.tsx